import { formatCustomDate, newDate } from "helpers/dateTools"
import { inventoryTypes } from "./types"
import { orderArrayV2 } from "helpers/orderArray"
import { inventoryDictionary } from "helpers/dictionary"

export const {
  INVENTORIES_INPUTS_FILTERS,
  GET_INVENTORIES,
  GET_INVENTORY_BY_ID,
  SET_INVENTORY_DATA_BY_TYPE,
  GET_INVENTORY_EXISTENCE,
  CREATE_GENERAL_INVENTORY,
  RESET_NEW_INVENTORY_MODE,
  SAVE_INVENTORY,
  SAVE_STATIONARY_INVENTORY,
  SAVE_LOCAL_INVENTORY,
  SAVE_STORAGES_INVENTORY,
  SELECT_INVENTORY,
  TANK_COUNTER,
  SET_INVENTORY_DATA,
  UPDATE_INVENTORY_PERCENTAGE,
  GET_STORAGES,
  UPDATE_UNIT_CIL,
  CLOSE_DELETE_INVENTORY,

  SET_CONFIG_PAGE_INVENTORIES,
  SET_CONFIG_PAGE_INVENTORIES_COUNT,
  SET_CONFIG_SORTED_INVENTORIES,
  SET_CONFIG_FILTERED_INVENTORIES,
  RESET_TABLE_CONTROLS,
  SET_MOBILE_ENDOWMENTS,

  GET_SHIPMENT_INVENTORY,
  GET_ALL_BY_SHIPMENT_NUMBER,
  DELETE_SHIPMENT,
  REOPEN_INVENTORY,
  GET_CARRIER_SHIPMENT_INVENTORY,
  REOPEN_CPV,
  RESTORE_INVENTORY_SAVE,
  MARK_INVENTORY_LOADED,
  UPDATE_DIGITAL_STATUS,
  SAVE_SHIPMENT,

  GET_ALL_SHIPPER_TRUCKS,
  GET_NATIONAL_NOTES_AVAILABLE,
  TOGGLE_NOTES_NATIONAL,
  GET_INVENTORY_CONFIG

} = inventoryTypes

const initialState = {
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
  station: null,
  inventories: [],
  inventory: {
    details: {
      mobileInventory: [],
      stationaryInventory: [],
      localInventory: [],
      storagesInventory: [],
      shipmentsInventory: [],
    },
    loaded: {
      mobileInventory: false,
      stationaryInventory: false,
      localInventory: false,
      storagesInventory: false,
      shipmentsInventory: false,
    },
    config: {}
  },

  subInventory: {},
  storages: [],
  carries: [],
  shipperTrucks: [],
  nationalNotes: [],
  tankTab: 0,
  isNew: false,
  mobileEndowments: [],
  storagesConfig: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: [],
  },
  localConfig: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: [],
  },
  stationaryConfig: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: [],
  },
  mobileConfig: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: [],
  }
}

export const inventoriesReducer = (state = initialState, { payload, type }) => {
  switch (type) {

    case INVENTORIES_INPUTS_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case GET_INVENTORIES:
      const mapData = payload.map((item) => {
        return {
          ...item,
          date: newDate({
            date: item.date.split("T")[0]
          }),
        }
      })
      return {
        ...state,
        inventories: orderArrayV2(mapData, 'date', true),
      }

    case CREATE_GENERAL_INVENTORY:
      return {
        ...state,
        inventories: [payload, ...state.inventories],
        isNew: true
      }
    case RESET_NEW_INVENTORY_MODE:
      return {
        ...state,
        isNew: false
      }
    case GET_INVENTORY_BY_ID:
      const { details } = payload
      const {
        mobileInventory,
        stationaryInventory,
        localInventory,
        storagesInventory,
      } = details

      let totalKgLocal = localInventory?.reduce((acc, curr) => acc + curr.totalKg, 0) || 0
      let totalKgStorages = storagesInventory?.reduce((acc, curr) => acc + curr.totalKg, 0) || 0;
      let totalKgStationary = stationaryInventory?.reduce((acc, curr) => acc + curr.totalKg, 0) || 0;
      let totalKgMobile = mobileInventory?.reduce((acc, curr) => acc + curr.totalKg, 0) || 0;
      let totalKgShipments = state.inventory.details?.shipmentsInventory?.reduce((acc, curr) => acc + curr.kilograms, 0) || 0;

      return {
        ...state,
        inventory: {
          ...payload,
          details: {
            ...details,
            mobileInventory: orderArrayV2(mobileInventory, 'number'),
            stationaryInventory: orderArrayV2(stationaryInventory, 'number'),
            localInventory: orderArrayV2(localInventory, 'number'),
            storagesInventory: orderArrayV2(storagesInventory, 'number'),
            shipmentsInventory: orderArrayV2(state.inventory.details?.shipmentsInventory)
          },
          totalKgStorages: totalKgStorages,
          totalKgStationary: totalKgStationary,
          totalKgLocal: totalKgLocal,
          totalKgMobile: totalKgMobile,
          totalKgShipments: totalKgShipments,
          physicalExistance: totalKgLocal + totalKgStorages + totalKgStationary + totalKgMobile,
          loaded: {
            mobileInventory: Array.isArray(mobileInventory),
            stationaryInventory: Array.isArray(stationaryInventory),
            localInventory: Array.isArray(localInventory),
          }
        }
      }
    case SET_INVENTORY_DATA_BY_TYPE:
      const newDetails = {
        ...state.inventory.details,
        [payload.keyInventory]: orderArrayV2(payload.data, 'number')
      }

      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: newDetails,
          totalKgStorages: newDetails.storagesInventory?.reduce((acc, curr) => acc + curr.totalKg, 0),
          totalKgStationary: newDetails.stationaryInventory?.reduce((acc, curr) => acc + curr.totalKg, 0),
          totalKgLocal: newDetails.localInventory?.reduce((acc, curr) => acc + curr.totalKg, 0),
          totalKgMobile: newDetails.mobileInventory?.reduce((acc, curr) => acc + curr.totalKg, 0)
        },
      }

    case SAVE_INVENTORY:
      const { data, key: keyInv } = payload
      const inventoryArr = [...state.inventories]
      const idxInv = inventoryArr.findIndex(inv => inv.id === data.id)
      inventoryArr[idxInv] = {
        ...inventoryArr[idxInv],
        ...data,
        physicalExistance: data.physicalExistance,
        difference: data.difference,
        sales: data.sales
      }


      return {
        ...state,
        inventories: inventoryArr,
        inventory: {
          ...state.inventory,
          [`${keyInv}_edited`]: false
        }
      }
    case SET_MOBILE_ENDOWMENTS:
      return {
        ...state,
        mobileEndowments: payload,
      }
    case GET_STORAGES:
      return {
        ...state,
        storages: payload
      }
    case GET_CARRIER_SHIPMENT_INVENTORY:
      return {
        ...state,
        carries: payload
      }
    case GET_ALL_SHIPPER_TRUCKS:
      return {
        ...state,
        shipperTrucks: payload,
      }
    case GET_NATIONAL_NOTES_AVAILABLE:
      return {
        ...state,
        nationalNotes: payload,
      }
    case TANK_COUNTER: {
      return {
        ...state,
        tankTab: payload
      }
    }
    case GET_INVENTORY_EXISTENCE:
      const nInventories = [...state.inventories]
      const invIdx = nInventories.findIndex(inv => inv.id === payload.id)
      if (invIdx === -1) return state
      nInventories[invIdx] = {
        ...payload,
        isCpv: nInventories[invIdx].isCpv,
        date: newDate({
          date: payload.date
        })
      }
      return {
        ...state,
        inventories: nInventories,
        inventory: {
          ...state.inventory,
          physicalExistance: payload?.physicalExistance,
        }
      }
    case REOPEN_CPV:
      const auxInventories = [...state.inventories]
      const inventoryFind = auxInventories.findIndex(inv => inv.id === payload)
      if (inventoryFind === -1) return state
      auxInventories[inventoryFind] = { ...auxInventories[inventoryFind], cpv: 0 }
      return {
        ...state,
        inventories: auxInventories,
      }
    case UPDATE_INVENTORY_PERCENTAGE:
      const { inventoryType, idUnit, percentage } = payload;
      const idx = inventoryType == inventoryDictionary.local
        ? state.inventory.details[inventoryType].findIndex(unit => unit.idTank === idUnit)
        : state.inventory.details[inventoryType].findIndex(unit => unit.idUnit === idUnit);

      if (idx === -1) return state;

      const updatedDetails = [...state.inventory.details[inventoryType]];
      const numericPercentage = isNaN(parseFloat(percentage)) ? 0 : parseFloat(percentage);
      const unitToUpdate = {
        ...updatedDetails[idx],
        currentPercentage: percentage,
        currentVolume: (updatedDetails[idx].totalVolume / 100) * numericPercentage,
        totalKg: ((updatedDetails[idx].totalVolume / 100) * numericPercentage) * 0.54
      };

      updatedDetails[idx] = unitToUpdate;

      const newDetailsUpdated = {
        ...state.inventory.details,
        [inventoryType]: updatedDetails
      }

      let local = state.inventory.totalKgLocal
      let stationary = state.inventory.totalKgStationary
      let mobile = state.inventory.totalKgMobile
      let storages = state.inventory.totalKgStorages

      switch (inventoryType) {
        case inventoryDictionary.storages:
          storages = newDetailsUpdated.storagesInventory.reduce((a, c) => (a += c.totalKg), 0)
          break
        case inventoryDictionary.mobile:
          mobile = newDetailsUpdated.mobileInventory.reduce((a, c) => (a += c.totalKg), 0)
          break
        case inventoryDictionary.stationary:
          stationary = newDetailsUpdated.stationaryInventory.reduce((a, c) => (a += c.totalKg), 0)
          break
        case inventoryDictionary.local:
          local = newDetailsUpdated.localInventory.reduce((a, c) => (a += c.totalKg), 0)
          break
        // case inventoryDictionary.shipment:
        //   shipment = newDetailsUpdated.shipment.reduce((a, c) => ( a += c.totalKg ), 0)
        //   break 
      }
      const physicalExistance = local + stationary + mobile + storages
      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: {
            ...state.inventory.details,
            [inventoryType]: updatedDetails
          },
          [`${inventoryType}_edited`]: true,
          physicalExistance: physicalExistance,
          totalKgStorages: storages,
          totalKgStationary: stationary,
          totalKgLocal: local,
          totalKgMobile: mobile
        },
      };

    case SET_INVENTORY_DATA:
      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: {
            ...state.inventory.details,
            [payload.key]: payload.value
          },
        }
      }

    case UPDATE_UNIT_CIL:
      const { idUnit: idUn, key, cil } = payload

      const updated = state.inventory.details.mobileInventory.map(unit => {
        if (unit.idUnit === idUn) {
          unit[key] = Number(cil)
          const cil10 = unit.cil10 * 10
          const cil20 = unit.cil20 * 20
          const cil30 = unit.cil30 * 30
          const cil45 = unit.cil45 * 45
          unit.totalKg = cil10 + cil20 + cil30 + cil45
        }
        return unit
      })
      const totalKg = updated.reduce((acc, curr) => acc + curr.totalKg, 0)
      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: {
            ...state.inventory.details,
            mobileInventory: updated
          },
          mobileInventory_edited: true,
          totalKgMobile: totalKg,
          physicalExistance: state.inventory.totalKgLocal + state.inventory.totalKgStationary + totalKg + state.inventory.totalKgStorages
        }
      }

    case CLOSE_DELETE_INVENTORY:
      const { id, del } = payload
      const closeDelState = [...state.inventories]
      const idxD = closeDelState.findIndex(inv => inv.id === id)
      if (idxD === -1) return state
      closeDelState[idxD].status = "CLOSED"
      return {
        ...state,
        inventories: del ? state.inventories.filter(inv => inv.id !== id) : closeDelState
      }

    case GET_SHIPMENT_INVENTORY:
      let cont = 0;
      const shipmentsWithNotesId = payload.map(s => {
        cont += s?.kilograms || 0;

        return {
          ...s,
          nationalNotesId: (s.nationalNotes || []).map(n => n.id)
        };
      });

      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: {
            ...state.inventory.details,
            shipmentsInventory: shipmentsWithNotesId,
          },
          totalKgShipments: cont,
        }
      }

    case GET_ALL_BY_SHIPMENT_NUMBER:
      const exists = state.inventory.details.shipmentsInventory.some(item => item?.id === payload?.id);
      const auxShipmentInventory = exists ? state.inventory.details.shipmentsInventory : [...state.inventory.details.shipmentsInventory, payload]
      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: {
            ...state.inventory.details,
            shipmentsInventory: auxShipmentInventory,
          },
          totalKgShipments: exists ? state?.inventory.totalKgShipments : state?.inventory.totalKgShipments + payload?.kilograms,
        }
      }

    case DELETE_SHIPMENT:
      const idz = state.inventory.details.shipmentsInventory.findIndex(shipment => shipment.id === payload)
      if (idz === -1) return state
      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: {
            ...state.inventory.details,
            shipmentsInventory: state.inventory.details.shipmentsInventory.filter(shipment => payload !== shipment.id),
          },
          totalKgShipments: state?.inventory.totalKgShipments - state?.inventory.details.shipmentsInventory[idz]?.kilograms,
        }
      }

    case REOPEN_INVENTORY:
      const inventories = [...state.inventories]
      const idxReopen = inventories.findIndex(inv => inv.id === payload)
      if (idxReopen === -1) return state
      inventories[idxReopen].status = "OPEN"
      return {
        ...state,
        inventories: inventories
      }
    case TOGGLE_NOTES_NATIONAL:
      const index = state.inventory.details.shipmentsInventory?.findIndex(s => s.id === payload.shipmentId);
      if (index === -1) return state;
      const shipmentsInventory = [...state.inventory.details.shipmentsInventory];
      const shipment = shipmentsInventory[index];
      const notes = new Set(shipment.nationalNotesId);
      if (notes.has(payload.id)) {
        notes.delete(payload.id);
      } else {
        notes.add(payload.id);
      }
      shipmentsInventory[index] = {
        ...shipment,
        nationalNotesId: Array.from(notes)
      };

      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: {
            ...state.inventory.details,
            shipmentsInventory
          }
        }
      };

    case SET_CONFIG_FILTERED_INVENTORIES:

      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          filtered: payload.data,
          page: 0,
        },
      };

    case SET_CONFIG_PAGE_INVENTORIES:

      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          pageSize: payload.data,
          page: 0,
        },
      };

    case SET_CONFIG_PAGE_INVENTORIES_COUNT:

      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          page: payload.data,
        },
      };
    case SET_CONFIG_SORTED_INVENTORIES:
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          sorted: payload.data,
          page: 0,
        },
      };
    case RESET_TABLE_CONTROLS:
      return {
        ...state,
        inventory: {},
        storagesConfig: {
          pageSize: 10,
          page: 0,
          sorted: [],
          filtered: [],
        },
        localConfig: {
          pageSize: 10,
          page: 0,
          sorted: [],
          filtered: [],
        },
        stationaryConfig: {
          pageSize: 10,
          page: 0,
          sorted: [],
          filtered: [],
        },
        mobileConfig: {
          pageSize: 10,
          page: 0,
          sorted: [],
          filtered: [],
        }
      };

    case RESTORE_INVENTORY_SAVE:
      return {
        ...state,
        inventory: {
          ...state.inventory,
          [payload]: false
        }
      }

    case MARK_INVENTORY_LOADED:
      return {
        ...state,
        inventory: {
          ...state.inventory,
          loaded: {
            ...state.inventory.loaded,
            [payload]: true,
          },
        },
      };

    case UPDATE_DIGITAL_STATUS:
      let digitalInventories = { ...state.inventory.details }

      let inventory = digitalInventories[payload.keyInventory].map(inv => {
        return inv.id === payload.id ? { ...inv, modificationRequestStatus: 'PENDING' } : inv
      })
      digitalInventories[payload.keyInventory] = inventory

      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: digitalInventories,
        }
      }

    case GET_INVENTORY_CONFIG:
      return {
        ...state,
        inventory: {
          ...state.inventory,
          config: payload
        }
      }
    
    case SAVE_SHIPMENT: {
      const { shipmentId, ...shipmentRest } = payload;
      const updatedShipments = state.inventory.details.shipmentsInventory.map((shipment) =>
          shipment.id === shipmentId ? { ...shipment, ...shipmentRest } : shipment
      );
      return {
        ...state,
        inventory: {
          ...state.inventory,
          details: {
            ...state.inventory.details,
            shipmentsInventory: updatedShipments,
          }
        }
      };
    }
    
    default:
      return state
  }
}